<style scoped>
    .vs-table--tbody-table .tr-values td {
        padding-top: 5px;
        padding-bottom: 5px;
    }
</style>
<template>
    <div>
        <vs-card class="p-4 mb-0">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">FGR Details</h4>
                </div>
                <div class="flex items-center">
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" icon="save" v-if="edit" @click="submitForm">Save</vs-button>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" icon="edit" @click="edit = true" v-if="!edit">Edit</vs-button>
                    <vs-dropdown vs-trigger-click v-if="!edit">
                        <vs-button class="btn mb-4 md:mb-0 mr-1" icon="apps">Process</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-group vs-collapse vs-label="Movement Order">
                                <vs-dropdown-group vs-collapse vs-label="Putaway">
                                    <vs-dropdown-item @click="createPutPartition()"> Background Putaway </vs-dropdown-item>
                                    <vs-dropdown-item @click="createPutPartition('foreground')"> Foreground Putaway </vs-dropdown-item>
                                    <vs-dropdown-item divider @click="getList('putaway')"> Putaway List </vs-dropdown-item>
                                </vs-dropdown-group>
                                <vs-dropdown-item divider > View Movement </vs-dropdown-item>
                                <vs-dropdown-item @click="confirmAll"> Confirm Movement </vs-dropdown-item>
                            </vs-dropdown-group>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="vx-row mt-5">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.reference" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            GR Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.gr" :disabled="!edit"/>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Status*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.status.name" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Client ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.vas.client.client_code" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Warehouse ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.vas.warehouse.warehouses_code" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Production ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.vas.id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            &nbsp;
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.vas.reference" disabled/>
                        </div>
                    </div>
                </div>
            </div>
            <vs-tabs class="mt-5">
                <vs-tab label="Item Details" class="pt-base">
                    <vs-table hoverFlat class="mt-base" :data="data.details">
                        <template slot="thead">
                            <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                            <vs-th style="min-width: 200px;">Product ID</vs-th>
                            <vs-th style="min-width: 200px;">Description</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                            <vs-th style="min-width: 80px; width: 80px">Qty</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">UoM</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Stock Type</vs-th>
                            <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Base UoM</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td>{{ indextr + 1 }}</vs-td>
                                <vs-td>{{ tr.product.product_code }}</vs-td>
                                <vs-td>{{ tr.product.description_1 }}</vs-td>
                                <vs-td>{{ tr.pack_id }}</vs-td>
                                <vs-td>{{ tr.batch }}</vs-td>
                                <vs-td>{{ tr.expired_date }}</vs-td>
                                <vs-td>{{ tr.qty }}</vs-td>
                                <vs-td>{{ tr.uom.name }}</vs-td>
                                <vs-td>{{ tr.stock_type.name }}</vs-td>
                                <vs-td>{{ tr.base_qty }}</vs-td>
                                <vs-td>{{ tr.product.base_uom.uom.name }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-tab>
                <vs-tab label="Notes" class="pt-base">
                </vs-tab>
                <vs-tab label="Attachment" class="pt-base">
                    <input 
              type="file" 
              id="file_name"
              v-on:change="handleFileUpload($event)" :hidden="!edit"
            />
                        <vs-table :data="attachments" :hidden="edit">
                            <template slot="thead">
                                <vs-th>No.</vs-th>
                                <vs-th>File Name</vs-th>
                                <vs-th>Action</vs-th>
                            </template>
                            <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="indextr">
                                    {{ indextr + 1 }}
                                </vs-td>
                                <vs-td :data="data[indextr].file_name">
                                    {{ data[indextr].file_name }}
                                </vs-td>
                                <vs-td :data="indextr">
                                    <vs-button color="success" class="btn mb-4 md:mb-0 mr-1" @click="removeDetail(index)" :disabled="editMode ? false : true">Download</vs-button>
                                    <vs-button color="danger" class="btn mb-4 md:mb-0 mr-1" @click="removeDetail(index)" :disabled="editMode ? false : true">Remove</vs-button>
                                </vs-td>
                            </vs-tr>
                            </template>
                        </vs-table>
                </vs-tab>
            </vs-tabs>
        </vs-card>
        <vs-popup
            :active.sync="printModal"
            title="Movement Orders"
        >
            <div class="flex flex-wrap items-center justify-end">
                <div class="flex items-center">
                    <vs-button class="btn mb-4 md:mb-0 mr-1" icon="print" @click="print">Print</vs-button>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions2"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="pickListDefs"
                :defaultColDef="defaultColDef2"
                :rowData="printData"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                rowHeight="35"
                headerHeight="35"
            >
            </ag-grid-vue>
        </vs-popup>
    </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'

export default {
    components: {
        AgGridVue,    
        flatPickr
    },
    data() {
        return {
            isLoading: false,
            data: {},
            details: [],
            components: [],
            edit: false,
            printModal: false,
            defaultColDef2: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            gridApi2: null,
            pickListDefs: null,
            printData: [],
            gridOptions2: {},
        }
    },
    watch: {
        isLoading: function() {
            if(this.isLoading) {
                this.$vs.loading();
            }
            else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        back() {
            this.$router.push({
                name: 'fg-receiving'
            });
        },
        fetchData() {
            this.isLoading = true;
            this.$http.get(`valueaddedservice/fgreceiving/view/${this.$route.params.id}`)
            .then(res => {
                this.data = res.data;
                // this.data.client_code = res.data.vas.client.client_code;
                // this.data.warehouses_code = res.data.vas.warehouse.warehouses_code;
                // this.data.status = res.data.status.name;
                this.isLoading = false;
            })
            .catch(error => this.handleError(error));
        },
        handleFileUpload(event){
                this.file = event.target.files[0];
            },
        submitForm() {
            let document_send = {
                module_id:this.$route.params.id,
                module_name:'fgr'
            };
                let file = new FormData();
            file.append("file_name",this.file);
            this.$http.post('/attachment/uploads',file,{
              headers: {
                  "Content-Type": "multipart/form-data"
              },
              params: document_send
            })
            .then((resp) => {
                // this.$router.replace('/inbound-delivery');
                // this.on_edit = false;
                this.isLoading = false

                this.$vs.notify({
                color: 'success',
                title: 'Update Success',
                text: 'Update Attachment Succesfully'
                });
                
               
            })
            .catch((error) =>{
                this.isLoading = false               
            });
            this.isLoading = true;
            this.$http.post(`valueaddedservice/${this.$route.params.id}/update`, this.data)
            .then(res => {
                this.data = res.data;
                this.data.client_code = res.data.client.client_code;
                this.data.warehouses_code = res.data.warehouse.warehouses_code;
                this.data.status = res.data.status.name;
                this.edit = false;
                this.isLoading = false;
            })
            .catch(error => this.handleError(error))
        },
        createPutPartition(type = 'background') {
            this.isLoading = true;

            this.$http.get(`valueaddedservice/fgreceiving/${this.$route.params.id}/createputpartition`)
            .then(res => {
                this.isLoading = false;
                this.$router.push({
                    name: `vas-put-${type}`,
                    params: {
                        data: res.data,
                        id: this.$route.params.id
                    }
                });
            })
            .catch(error => this.handleError(error));
        },
        confirmAll() {
            this.isLoading = true;

            this.$http.get(`valueaddedservice/fgreceiving/${this.$route.params.id}/confirmallmovement`)
            .then(res => {
                this.isLoading = false;

                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: res.data.message || 'Success confirm'
                });

                this.fetchData();
            })
            .catch(error => this.handleError(error))
        },
        release() {
            this.isLoading = true;

            this.$http.get(`valueaddedservice/${this.$route.params.id}/release`)
            .then(res => {
                this.isLoading = false;

                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: res.data.message || 'Success'
                });

                this.fetchData();
            })
            .catch(error => this.handleError(error))
        },
        getList(type = 'picking') {
            let types = type == 'picking' ? ['PO-PICK'] : ['FGR-PUT'];

            this.isLoading = true;

            this.$http.post('inventories/movementorder/list', {
                fgr_id: this.$route.params.id,
                type: types
            })
            .then(res => {
                this.gridApi2 = this.gridOptions2.api;
                this.printData = res.data;
                this.printModal = true;
                this.isLoading = false;
            })
            .catch(error => this.handleError(error))
        },
        print() {
            if(this.gridApi2.getSelectedRows().length < 1) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'No data selected.'
                });

                return false;
            }
                
            const id = this.gridApi2.getSelectedRows().map(item => {
                return item.id;
            })

            this.isLoading = true;

            this.$http.post('inventories/movementorder/print', {id: id}, { responseType: 'blob' })
            .then(response => {
                this.isLoading = false
                var blob = new Blob([response.data], {
                    type: 'application/pdf'
                })
                window.open(URL.createObjectURL(blob));
            })
            .catch(error => this.handleError(error));
        }
    },
    mounted() {
        this.fetchData();
        this.$http.get('attachment/'+this.$route.params.id).then((res) => {
            this.attachments = res.data.result
        });
    },
    beforeMount() {
        this.pickListDefs = [
            {
                headerName: 'ID',
                field: 'id',
                width: 250,
            },
            {
                headerName: 'Movement Date',
                field: 'movement_date',
                width: 250,
            },
        ];

        this.gridOptions2.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>